class ReflectionScroll extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.contentEl = this.querySelector('[data-reflection-content]');
    this.reflectionEl = this.querySelector('[data-reflection-copy]');
    this.contentItems = [...this.contentEl.querySelectorAll('.item__inner')];
    this.reflectionItems = [...this.reflectionEl.querySelectorAll('.item__inner')];
    this.timelines = [];

    this.preloadImages().then(() => {
      if (!this.isConnected) return;
      this.classList.remove('is-loading');
      this.init();
    });
  }

  disconnectedCallback() {
    if (this.rafId) cancelAnimationFrame(this.rafId);
    if (this.lenis) this.lenis.destroy();
    if (this.handleNativeScroll) window.removeEventListener('scroll', this.handleNativeScroll);
    this.timelines.forEach((timeline) => {
      if (timeline.scrollTrigger) timeline.scrollTrigger.kill();
      timeline.kill();
    });
    this.timelines = [];
    this.initialized = false;
  }

  preloadImages() {
    return new Promise((resolve) => {
      const images = this.querySelectorAll('.item__img-inner');
      if (typeof window.imagesLoaded !== 'function') {
        resolve();
        return;
      }
      window.imagesLoaded(images, { background: true }, resolve);
    });
  }

  init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.gsap || !window.ScrollTrigger || !window.Lenis) return;

    window.gsap.registerPlugin(window.ScrollTrigger);
    if (window.self === window.top) {
      this.initSmoothScrolling();
    } else {
      this.initNativeScrolling();
    }
    this.initScrollAnimations();
  }

  initNativeScrolling() {
    this.handleNativeScroll = () => {
      this.reflectionEl.style.transform = `translateY(${-window.scrollY}px)`;
      window.ScrollTrigger.update();
    };

    window.addEventListener('scroll', this.handleNativeScroll, { passive: true });
    this.handleNativeScroll();
  }

  initSmoothScrolling() {
    this.lenis = new window.Lenis({
      lerp: .2,
      smoothWheel: true,
    });

    this.lenis.on('scroll', () => window.ScrollTrigger.update());

    const scrollFrame = (time) => {
      if (!this.isConnected) return;
      this.lenis.raf(time);
      this.reflectionEl.style.transform = `translateY(${-this.lenis.actualScroll}px)`;
      this.rafId = requestAnimationFrame(scrollFrame);
    };

    this.rafId = requestAnimationFrame(scrollFrame);
  }

  initScrollAnimations() {
    this.contentItems.forEach((item, position) => {
      const reflectionItem = this.reflectionItems[position];

      if (!reflectionItem) return;

      const timeline = window.gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      });

      timeline
        .fromTo(
          [item, reflectionItem],
          {
            transformOrigin: '50% 120%',
            filter: 'contrast(120%) brightness(100%)',
          },
          {
            ease: 'power1.in',
            rotationX: 70,
            z: -300,
            scaleY: .8,
            filter: 'contrast(65%) brightness(30%)',
          },
          0,
        )
        .fromTo(
          [item.querySelector('.item__img-inner'), reflectionItem.querySelector('.item__img-inner')],
          { scale: 1 },
          {
            ease: 'sine.inOut',
            scale: 1.3,
          },
          0,
        );

      this.timelines.push(timeline);
    });
  }
}

if (!customElements.get('reflection-scroll')) {
  customElements.define('reflection-scroll', ReflectionScroll);
}
